import "./contact-us.scss";

function Contact() {
  return (
    <section className="contact" id="Contact">
      <div className="heading">
        <h1>Contact Us</h1>
        <span className="heading-medium">Contect us to Join us</span>
        <span className="heading-small">
          We're here to help! If you have any questions or concerns, please
          don't hesitate to get in touch with us.
        </span>
      </div>
    </section>
  );
}

export default Contact;
